import React, { useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import Box from '@node-space/storybook-components/dist/Box'
import PageHeader from '@node-space/storybook-components/dist/PageHeader'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { Button, Icon } from '@node-space/ui-components'
import { useCustomerQuery } from 'hooks/queries/Customers/useCustomerQuery'
import { useGetCustomersWalletQuery } from 'hooks/queries/Customers/useGetCustomersWallets'
import { currentCustomerAtom, currentCustomerWalletAtom } from './atoms/customersAtoms'
import CustomerWalletPageHeader from './components/CustomerWallet/CustomerWalletPageHeader'
import { CustomerWalletPageParams } from './types'

export const CustomerWallet = () => {
  const { t } = useTranslation()
  const setCurrentCustomerAtom = useSetAtom(currentCustomerAtom)
  const setCurrentCustomerWalletAtom = useSetAtom(currentCustomerWalletAtom)
  const { customerReference, customerWalletId }: CustomerWalletPageParams = useParams()

  const {
    data: customer,
    error: customerError,
    isFetching: isFetchingCustomer,
  } = useCustomerQuery(customerReference)
  const {
    data: customerWallet,
    isFetching: isFetchingCustomerWallet,
    error: customerWalletError,
  } = useGetCustomersWalletQuery(customerWalletId, !!customerWalletId)

  useEffect(() => {
    setCurrentCustomerAtom(customer)
  }, [customer])

  useEffect(() => {
    setCurrentCustomerWalletAtom(customerWallet)
  }, [customerWallet])

  return (
    <>
      <PageHeader
        description={
          <CustomerWalletPageHeader
            customerWallet={customerWallet}
            isLoading={isFetchingCustomerWallet || isFetchingCustomer}
          />
        }
        renderRightSection={
          <Box flex gapX={12}>
            <Button iconElement={<Icon name="ArrowsLeftRight" />}>{t('customers.move')}</Button>
            <Button iconElement={<Icon name="ArrowDownLeft" />}>{t('deposit')}</Button>
          </Box>
        }
      />
      <Box flex className="md:flex-row" direction="col" gapX={24} gapY={24} width="full">
        <StatusCard
          className="w-full"
          headline={t('customers.noTransactionsHeadline')}
          description={t('customers.noTransactionsDescription')}
        />
      </Box>
    </>
  )
}
